import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ShieldAlert } from "lucide-react";
import { useLang, useT } from "@/lib/i18n";
import { TERMS } from "@/lib/terms";

const KEY = "fhp-terms-accepted-v1";
export const termsAccepted = () => { try { return !!localStorage.getItem(KEY); } catch { return false; } };
const accepted = termsAccepted;
export const GATE_FREE = ["/terms", "/privacy", "/about", "/guide", "/faq"];

export function DisclaimerGate() {
  const t = useT();
  const { pathname } = useLocation();
  const [ok, setOk] = useState(accepted);
  if (ok || GATE_FREE.includes(pathname)) return null;
  const agree = () => {
    try { localStorage.setItem(KEY, new Date().toISOString()); } catch { /* private mode */ }
    setOk(true);
    window.dispatchEvent(new Event("terms-accepted"));
  };
  return (
    <div className="gate-sheet" data-testid="disclaimer-gate" role="dialog" aria-label={t("Before you use Fuel Hauler Pro")}>
      <div className="gate gate-compact">
        <p className="gate-short"><ShieldAlert size={18} />{t("Fuel Hauler Pro gives estimates, not certified tank readings. Always check the store's chart, the console and your stick before you drop.")}</p>
        <div className="gate-row">
          <Link to="/terms" className="gate-link" data-testid="disclaimer-read-terms">{t("Full terms")}</Link>
          <Link to="/privacy" className="gate-link" data-testid="disclaimer-read-privacy">{t("Privacy")}</Link>
          <button type="button" className="primary-btn gate-agree" data-testid="disclaimer-agree-button" onClick={agree}>{t("I agree")}</button>
        </div>
      </div>
    </div>
  );
}

export function ShortDisclaimer({ testID = "short-disclaimer" }) {
  const { lang, terms } = useLang();
  return (
    <p className="short-disclaimer" data-testid={testID}>
      {terms.short} <Link to="/terms" data-testid={`${testID}-link`}>{lang === "es" ? "Términos" : "Terms"}</Link> · <Link to="/privacy" data-testid={`${testID}-privacy`}>{lang === "es" ? "Privacidad" : "Privacy"}</Link>
    </p>
  );
}
